import type { IErrorResponse, ProductGroup } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const usePostFavorite = (): UseMutationResult<
  { id: string; product_group: ProductGroup; user_code: string },
  IErrorResponse,
  { product_group_code: number }
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.productFavorites, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('submitProductToFavorites'),
      });
    },
  });
};
export default usePostFavorite;
